<div
  class="section-wrapper flex flex-col"
  *ngIf="ventilationSchedule$ | async | ready as ventilationSchedule"
>
  <app-timemanager
    data-at-ventilation-schedule
    class="gap"
    (scheduleChange)="onScheduleChange($event, ventilationSchedule)"
  >
  </app-timemanager>

  <div
    *ngIf="editMultipleDays"
    class="programs-container gap flex flex-row justify-between items-center"
  >
    <button
      mat-stroked-button
      color="primary"
      gtm="onOpen"
      gtmAction="Multiple days selection dialog"
      gtmCategory="ventilationSchedule"
      id="edit-multiple-ventilation-btn"
      data-at-edit-multiple
      (click)="onEditMultipleDays()"
    >
      {{ '+SCHEDULES.BUTTON.EDIT_MULTIPLE_DAYS' | translate }}
    </button>
    <div data-at-programs class="programs flex flex-row flex-wrap">
      <vi-program-item
        [attr.data-at-ventilation-operating-program]="program?.name"
        *ngFor="let program of programsDetails"
        [program]="program.css"
        [hasTemperature]="false"
      >
        <vi-text name class="flex-1">
          {{ program?.displayName }}
        </vi-text>
      </vi-program-item>
    </div>
  </div>
</div>
